import { __assign } from "tslib";
import flatten from 'lodash/flatten';
import isUndefined from 'lodash/isUndefined';
import last from 'lodash/last';
import merge from 'lodash/merge';
import omitBy from 'lodash/omitBy';
import uniq from 'lodash/uniq';
var extractFromContext = function (event, property) {
    return event.context.map(function (item) { return item[property]; });
};
export var getAnalyticsType = function (event) {
    return event.payload.analyticsType;
};
export var getAttributes = function (event) {
    var contextAttributes = extractFromContext(event, 'attributes');
    var payloadAttributes = event.payload.attributes;
    var allAttributes = merge(contextAttributes.reduce(function (result, extraAttributes) { return merge(result, extraAttributes); }, {}), payloadAttributes);
    var sources = extractFromContext(event, 'source');
    var namespaces = sources.filter(Boolean).join('.');
    return omitBy(__assign(__assign({}, allAttributes), { namespaces: namespaces }), isUndefined);
};
export var getSource = function (event) {
    return last(extractFromContext(event, 'source').filter(Boolean));
};
export var getActionSubject = function (event) {
    var actionSubject = event.payload.actionSubject;
    if (actionSubject) {
        return actionSubject;
    }
    var component = last(extractFromContext(event, 'component').filter(Boolean)) ||
        last(extractFromContext(event, 'componentName').filter(Boolean));
    return component;
};
export var getAction = function (event) { return event.payload.action; };
export var getActionSubjectId = function (event) {
    return event.payload.actionSubjectId;
};
export var getContainerId = function (event) {
    return last(extractFromContext(event, 'containerId').filter(Boolean));
};
export var getContainerType = function (event) {
    return last(extractFromContext(event, 'containerType').filter(Boolean));
};
export var getObjectId = function (event) {
    return last(extractFromContext(event, 'objectId').filter(Boolean));
};
export var getObjectType = function (event) {
    return last(extractFromContext(event, 'objectType').filter(Boolean));
};
export var getTags = function (event) {
    var tags = uniq(flatten(extractFromContext(event, 'tags'))).filter(Boolean);
    return tags.length ? tags : undefined;
};
//# sourceMappingURL=utils.js.map